"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.patchBulkStatus = void 0;
/**
 * Patch multiple job statuses by jobId and status, sent in the request body.
 */
var patchBulkStatus = function (instance) {
    return function (body, config) {
        return instance.patch("/jobs/status/bulk", body, config);
    };
};
exports.patchBulkStatus = patchBulkStatus;
